import { ResponseType } from 'axios';
import { HTTP_METHOD } from 'src/constants/api';
import {instanceToPlain} from 'class-transformer';

export abstract class DTO {
	public abstract param: object | undefined;
	public abstract query: unknown;
	public abstract body: unknown;
	public abstract readonly url: string;
	public abstract readonly method: HTTP_METHOD;
	public responseType?: ResponseType;
	public headers?: object;
	public interpolatedUrl(baseUrl?: string): string {
		let url = (baseUrl || '') + this.url;
		if (this.param) {
			const params = instanceToPlain(this.param, { excludeExtraneousValues: true });
			Object.keys(params).forEach((key) => {
				url = url.replace(':' + key, String(params[key]));
			});
		}
		return encodeURI(url);
	}
}

export abstract class ResponseDTO<T> {
	public readonly responseKey?: string;
	public readonly timestamp?: string;
	public abstract readonly data: T | undefined;
}

export interface IBasePaginationRequest {
	pageNumber?: number;
	pageSize?: number;
}

export abstract class PaginationResponseDTO<T> extends ResponseDTO<T> {
	public readonly totalRecords?: number;
	public readonly totalPages?: number;
	public readonly pageNumber?: number;
	public readonly pageSize?: number;
}
